import React from 'react';
import { ThemeProvider, Typography } from '@mui/material';
import { translate } from 'react-jhipster';

// TODO refactor to reduce input params and move data into internal state where possible
export const QuotationTitle = ({ purchaseCancellation, quotationEntity, responsiveFont }) => {
  if (purchaseCancellation?.id > 0 && quotationEntity?.cancelOrder === true) {
    return (
      <ThemeProvider theme={responsiveFont}>
        <Typography variant="h4" component="div">
          {translate('comexApp.quotation.home.orderCancel')}
        </Typography>
      </ThemeProvider>
    );
  } else if (quotationEntity?.status === 'Transferred') {
    return (
      <ThemeProvider theme={responsiveFont}>
        <Typography variant="h4" component="div">
          {translate('comexApp.quotation.orderTransferred')}
        </Typography>
      </ThemeProvider>
    );
  } else if (
    ((quotationEntity?.status === 'Bought' ||
      quotationEntity?.status === 'Quoted' ||
      quotationEntity?.status === 'Kept' ||
      quotationEntity?.status === 'Sold') &&
      purchaseCancellation?.id === undefined) ||
    quotationEntity?.cancelOrder === false ||
    quotationEntity?.cancelOrder === null
  ) {
    return (
      <ThemeProvider theme={responsiveFont}>
        <Typography variant="h4" component="div">
          {translate('comexApp.quotation.home.orderBought')}
        </Typography>
      </ThemeProvider>
    );
  } else {
    return <></>;
  }
};
